import React from 'react';
import { Carousel } from "antd";
import { imageUrl, zeusApp } from '../request/index';
import { useCustomData } from '../pages/context/aboutCustomDataProvider';

const AboutSwiper: React.FC = () => {
    const contentStyle: React.CSSProperties = {
        margin: 0,
        height: '603px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#0e08f9',
    };
    const { getValue } = useCustomData();
    const AboutHomeBanner = getValue('AboutHomeBanner');
    console.log(AboutHomeBanner)

    return (
        <div className="about-swiper">
            <div>
                <div style={contentStyle}>
                    <img
                        src={`${imageUrl}${AboutHomeBanner}?zeus-app=${zeusApp}`}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AboutSwiper;